"use client";

import { motion } from "framer-motion";
import { PageCareerSchema } from "@/sanity/pages/PageCareerTemplate";
import Image from "next/image";
import { PortableText } from "@portabletext/react";
import { customRichTextComponent, richTextComponent } from "@/sanity/sanityPortableText";
import { CTAButton } from "@/shadcn/ui/button";
import ChipStatue from "@/components/global/ui/ChipStatue";
import archerChip from "@/public/global/archerChip.png";

export default function PositionsSection({ data }: { data: PageCareerSchema }) {
  return (
    <section className="relative py-[8rem] lg:py-[15rem]">
      <div className="flex relative flex-col gap-[4rem] lg:gap-[6rem] w-[min(94.375rem,100%)] mx-auto">
        <div className="container flex relative z-10 flex-col items-center px-[2.25rem]">
          <div className="hidden lg:block">
            <ChipStatue
              className="mb-[2.5rem]"
              image={archerChip}
            />
          </div>

          {data?.positionsTitle && (
            <div className="flex flex-col lg:items-center richtext rose-headings:mb-[2.5rem] richtext-start 6 lg:richtext-center lg:[&_span]:font-display lg:[&_span]:font-[700] [&_span]:font-instrument-sans [&_span]:font-[600] [&_span]:text-[#103037] lg:[&_span]:text-[#65A38A] prose-strong:text-black prose-strong:font-[400] prose-headings:text-[5rem] lg:prose-headings:text-[7rem] lg:prose-headings:mb-[1.5rem]">
              <PortableText
                value={data.positionsTitle}
                components={customRichTextComponent({
                  block: {
                    normal: ({ children }) => (
                      <p className="text-[2rem] font-geist leading-[140%] text-[#1C1F22]/80 mb-0 tracking-[-0.045rem] capitalize w-[min(41.5rem,100%)]">
                        {children}
                      </p>
                    ),
                  },
                })}
              />
            </div>
          )}
        </div>

        {data?.positionsCards && (
          <div className="flex flex-col items-center lg:px-0 gap-[1.5rem] px-[2rem]">
            {data.positionsCards.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{
                  duration: 0.6,
                  delay: index * 0.1,
                  ease: [0.25, 0.1, 0.25, 1],
                }}
                className="flex flex-col w-full p-[2.5rem] rounded-[2rem] bg-[#F0F4F2]">
                {item.title && (
                  <p className="text-[2.75rem] leading-[150%] font-gestura text-[#103037] font-[600] mb-[1rem]">
                    {item.title}
                  </p>
                )}
                {item.details && (
                  <p className="text-[2rem] font-geist leading-[150%] text-[#103037]/80 mb-0">{item.details}</p>
                )}
                <hr className="w-full border-t my-[1rem] border-[#103037]/10" />
                {item.description && (
                  <p className="text-[2rem] font-geist leading-[150%] text-[#103037]/80 mb-0">{item.description}</p>
                )}
                {item.cta && (
                  <div className="w-fit mt-[2rem]">
                    <CTAButton data={item.cta} />
                  </div>
                )}
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
